import React from "react";
import { useState } from "react";
import { IconContext } from "react-icons";
import { FaUser } from "react-icons/fa";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import BackButton from "../../../../reusable-components/buttons/BackButton";
import H2withIcon from "../../../../reusable-components/headings/H2withIcon";

import { useEffect } from "react";
import sabccoLogo from "../../../../assets/SABCCO_128x128.png";
import { formatINRCurrency } from "../../../../utilities/currency/currency";

import LoadingModal from "../../../../reusable-components/modals/LoadingModal";
import { getFormattedDateDDMMYYYY } from "../../../../utilities/dateFunctions/formatdate";
import TextArea from "../../../../reusable-components/inputs/InputTextAreas/TextArea";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import { button, delete_button } from "../../../../theme/lightTheme";
import { useForm } from "react-hook-form";
import ConfirmationModal from "../../../../reusable-components/modals/ConfirmationModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import {
  APPLICANT_PERSONAL_DETAILS_CONFIG_URL,
  NOC_APPLICATION_LIST_URL,
  VERIFY_NOC_APPLICATION_URL,
} from "../../../../api/api_routing_urls";
import Dropdown from "../../../../reusable-components/inputs/Dropdowns/Dropdown";
import { rePaymentFormModeDD } from "../../../../utilities/constants/constants";
import QRCode from "react-qr-code";
import { PrintNOCApplication } from "../../../system-admin/ReportsList/PrintReport/PrintNOCApplication";

export default function ViewNocApplication({
  nocApplicationDetail,
  setViewNocApplicationDetail,
  setNocApplicationDetail,
  setRefresh,
}) {
  const [showBackButton, setShowBackButton] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [remark, setRemark] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showRevertModal, setShowRevertModal] = useState(false);
  const [remarkError, setRemarkError] = useState(true);

  const [qrCodeUrl, setQRCodeUrl] = useState(null);

  const axiosPrivate = useAxiosPrivate();
  const controller = new AbortController();
  const { auth } = useAuth();
  const paymentModeColor = {
    Cash: "bg-green-100 text-green-700",
    Cheque: "bg-yellow-100 text-yellow-700",
    Branch: "bg-blue-100 text-blue-700",
    Others: "bg-slate-100 text-slate-700",
  };

  const [selectedPaymentMode, setSelectedPaymentMode] = useState(
    nocApplicationDetail?.convenience_fee_payment_mode
      ? {
          value: nocApplicationDetail.convenience_fee_payment_mode,
          label: nocApplicationDetail.convenience_fee_payment_mode,
        }
      : rePaymentFormModeDD[0],
  );

  const [paymentReference, setPaymentReference] = useState(
    nocApplicationDetail?.payment_reference || "",
  );

  const [paymentRemark, setPaymentRemark] = useState(
    nocApplicationDetail?.payment_remark || "",
  );

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
    control,
  } = useForm({
    mode: "onChange",
    defaultValues: "",
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    try {
      if (data?.remarks !== "") {
        setRemarkError(false);
      } else {
        setRemarkError(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const verifyNocApplication = async ({ is_loanee }) => {
    let formDataObj = {};
    try {
      formDataObj.noc_serial_no = nocApplicationDetail.noc_serial_no;
      formDataObj.isverified = true;
      formDataObj.remark = remark;
      formDataObj.isloanee = is_loanee;

      let response = await axiosPrivate.post(
        `${VERIFY_NOC_APPLICATION_URL}`,
        formDataObj,
        {
          signal: controller.signal,
        },
      );

      if (response?.status === 200) {
        setRefresh((prev) => !prev);
        showToast("Applicant has been verified successfully", "success");
        getNocApplicationDetails();
        setShowModal(false);
        setShowRevertModal(false);
      }
      response?.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      setShowModal(false);
      console.error(error.message);
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error",
        );
      }
    }
  };

  const verifyNocApplicationPayment = async () => {
    let formDataObj = {};
    try {
      formDataObj.noc_serial_no = nocApplicationDetail.noc_serial_no;
      formDataObj.payment_reference = paymentReference;
      formDataObj.payment_remark = paymentRemark;
      formDataObj.payment_received_by = auth?.username || "admin";
      formDataObj.convenience_fee_payment_mode = selectedPaymentMode?.value;

      let response = await axiosPrivate.post(
        `${VERIFY_NOC_APPLICATION_URL}/payment`,
        formDataObj,
        {
          signal: controller.signal,
        },
      );

      if (response?.status === 200) {
        setRefresh((prev) => !prev);
        showToast(
          "Applicant Payment details has been updated successfully",
          "success",
        );
        setShowModal(false);
        getNocApplicationDetails();
      }
      response?.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      setShowModal(false);
      console.error(error.message);
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error",
        );
      }
    }
  };

  const getNocApplicationDetails = async () => {
    try {
      setIsLoading(true);
      const response = await axiosPrivate.get(
        `${NOC_APPLICATION_LIST_URL}`,
        {
          params: {
            pgno: 1,
            pagesize: 1,
            searchtext: nocApplicationDetail.noc_serial_no || "",
          },
        },
        {
          signal: controller.signal,
        },
      );

      console.log("response", response?.data?.nocApplicationList);

      if (response.status === 200) {
        setNocApplicationDetail(response?.data?.nocApplicationList?.data[0]);
      }
      response.status === 202 &&
        showToast("No Death List  found in the system", "error");
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error",
        );
      }
    }
  };

  const is_parcha =
    nocApplicationDetail?.noc_purpose === "REGISTRATION/MUTATION" ||
    nocApplicationDetail?.noc_purpose === "PARCHA" ||
    nocApplicationDetail?.noc_purpose === "registration/property mutation" ||
    nocApplicationDetail?.noc_purpose === "lost of Parcha";

  useEffect(() => {
    if (nocApplicationDetail) setIsLoading(false);
  }, [nocApplicationDetail]);

  useEffect(() => {
    if (!nocApplicationDetail.noc_serial_no) {
      console.error("Unique serial number is not provided");
      return;
    }

    const textToEncode = `https://sikkimsabcco.com/view-noc-application/${nocApplicationDetail.noc_serial_no}`;
    setQRCodeUrl(textToEncode); // Set the QR code URL
  }, [nocApplicationDetail.noc_serial_no]);

  return !isLoading ? (
    <>
      <div className="flex items-center justify-between ">
        <H2withIcon>
          <IconContext.Provider value={{ className: "text-secondary" }}>
            <FaUser />
          </IconContext.Provider>
          &nbsp; Loanee Death Case Details
        </H2withIcon>
        {!showBackButton && (
          <BackButton
            label="back to list"
            onclick={() => {
              setShowBackButton(true);
              setViewNocApplicationDetail(false);
              setNocApplicationDetail({});
            }}
          />
        )}
      </div>
      <div className="mb-3 rounded-xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-200 px-4 py-3">
          <h3 className="text-base font-semibold text-slate-800">
            Application Progress
          </h3>

          <p className="mt-0.5 text-xs text-slate-500">
            Current processing status of this application.
          </p>
        </div>

        <div className="p-4">
          <div className="flex flex-col gap-3 md:flex-row md:items-center">
            {/* Submitted */}
            <div className="flex flex-1 items-center gap-2">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-500 text-sm font-semibold text-white">
                ✓
              </div>

              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-800">Submitted</p>
                <p className="text-xs leading-4 text-slate-500">
                  Application received
                </p>
              </div>
            </div>

            <div className="hidden h-px flex-1 bg-slate-200 md:block" />

            {/* Payment */}
            <div className="flex flex-1 items-center gap-2">
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white ${
                  nocApplicationDetail?.is_convenience_fee_paid
                    ? "bg-green-500"
                    : "bg-amber-500"
                }`}
              >
                {nocApplicationDetail?.is_convenience_fee_paid ? "✓" : "2"}
              </div>

              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-800">Payment</p>

                <p className="text-xs leading-4 text-slate-500">
                  {nocApplicationDetail?.is_convenience_fee_paid
                    ? "Payment recorded"
                    : "Awaiting payment"}
                </p>
              </div>
            </div>

            <div className="hidden h-px flex-1 bg-slate-200 md:block" />

            {/* Verification */}
            <div className="flex flex-1 items-center gap-2">
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white ${
                  nocApplicationDetail?.isverified
                    ? "bg-green-500"
                    : nocApplicationDetail?.is_convenience_fee_paid
                      ? "bg-blue-500"
                      : "bg-slate-300"
                }`}
              >
                {nocApplicationDetail?.isverified ? "✓" : "3"}
              </div>

              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-800">
                  Verification
                </p>

                <p className="text-xs leading-4 text-slate-500">
                  {nocApplicationDetail?.isverified
                    ? "Completed"
                    : nocApplicationDetail?.is_convenience_fee_paid
                      ? "Ready for verification"
                      : "Waiting for payment"}
                </p>
              </div>
            </div>

            <div className="hidden h-px flex-1 bg-slate-200 md:block" />

            {/* Decision */}
            <div className="flex flex-1 items-center gap-2">
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white ${
                  nocApplicationDetail?.isverified
                    ? nocApplicationDetail?.isloanee
                      ? "bg-red-500"
                      : "bg-green-500"
                    : "bg-slate-300"
                }`}
              >
                {nocApplicationDetail?.isverified ? "✓" : "4"}
              </div>

              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-800">Decision</p>

                <p className="text-xs leading-4 text-slate-500">
                  {nocApplicationDetail?.isverified
                    ? nocApplicationDetail?.isloanee
                      ? "Rejected"
                      : "Approved"
                    : "Pending"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-3 rounded-lg border border-slate-200 bg-slate-50 p-3 md:grid-cols-4">
        <div className="min-w-0">
          <p className="mb-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-500">
            Serial No.
          </p>
          <p className="truncate text-sm font-semibold text-slate-800">
            {nocApplicationDetail?.noc_serial_no}
          </p>
        </div>

        <div className="min-w-0">
          <p className="mb-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-500">
            Applicant
          </p>
          <p className="truncate text-sm font-semibold text-slate-800">
            {nocApplicationDetail?.noc_name}
          </p>
        </div>

        <div className="min-w-0">
          <p className="mb-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-500">
            Purpose
          </p>
          <p className="truncate text-sm font-semibold text-slate-800">
            {nocApplicationDetail?.noc_purpose || "-"}
          </p>
        </div>

        <div className="min-w-0">
          <p className="mb-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-500">
            Department
          </p>
          <p className="truncate text-sm font-semibold text-slate-800">
            {nocApplicationDetail?.noc_department_name || "-"}
          </p>
        </div>
      </div>
      {/* <section className=" text-[14px] p-9 text-justify bg-yellow-50 border rounded-xl mt-3">
        <div className="w-full">
          <div className="flex gap-3 items-center my-3 w-fit mx-auto">
            <img className="h-16 w-16" src={sabccoLogo} />
            <div>
              <p className="text-center text-[16px] font-semibold">
                Sikkim SC / ST / OBC Development Corporation.Ltd. (SABCCO)
              </p>
              <p className="text-[14px]  -mt-1">
                Chorten Monastery Road, Deorali, Gangtok, Sikkim - 737102
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between">
          {nocApplicationDetail.noc_serial_no ? (
            <>
              <p className="font-semibold">
                Serial No.: {nocApplicationDetail.noc_serial_no}
              </p>
            </>
          ) : null}

          {nocApplicationDetail.createdat ? (
            <>
              <p className="font-semibold">
                Date:{" "}
                {getFormattedDateDDMMYYYY(nocApplicationDetail?.createdat)}
              </p>
            </>
          ) : null}
        </div>

        <div className="mb-9">
          <p className="font-semibold text-center mb-6">
            TO WHOM IT MAY CONCERN
          </p>
          <p>
            This is to certify that Shri/Smt/Kumari
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_name}{" "}
            </span>
            , S/o, D/o, W/o
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_relative_name}{" "}
            </span>
            , resident of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_resident}{" "}
            </span>
            , does not have any outstanding loan or other dues as reflected in
            the books of this Corporation. Hence, this Corporation has no
            objection to the applicant obtaining this No Objection Certificate
            for the purpose of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_purpose}{" "}
            </span>
            {nocApplicationDetail?.noc_department_name && (
              <>
                {" "}
                in{" "}
                <span className="font-semibold">
                  {nocApplicationDetail?.noc_department_name}
                </span>
                {String(nocApplicationDetail?.noc_department_name).includes(
                  "Department",
                ) ||
                String(nocApplicationDetail?.noc_department_name).includes(
                  "Dept.",
                )
                  ? null
                  : " Department"}
              </>
            )}
            .
          </p>

          {is_parcha ? (
            <p className="pt-3">
              Percha/Land Title bearing Khatian No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khatian_no}{" "}
              </span>{" "}
              Khasra No./Plot No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khasra_no}{" "}
              </span>{" "}
              and Area of{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_area}{" "}
              </span>{" "}
              Hectares registered in the name{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.parcha_holder_name}{" "}
              </span>{" "}
              situated at{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_situated}{" "}
              </span>
            </p>
          ) : null}

          <p className="pt-3">
            This certificate is issued without prejudice to the Corporation's
            right to recover the loan amount if it is found at any later point
            of time that he/she owes any amount to this Corporation.
          </p>

          <p className="pt-3">
            This certificate is valid for a period of 6 (Six) months from the
            date of issue.
          </p>
        </div>

        <div className="flex flex-row justify-between pt-6">
          <p className="font-semibold">{formatINRCurrency(150)}/-</p>
          <div>
            <p className="mt-16">Asstt. Manager/Manager/Dy.G.M</p>
          </div>
        </div>
      </section> */}
      <>
        <h6 className="text-lg font-semibold text-center text-slate-800 mt-9 mb-3">
          Preview of the NOC application
        </h6>

        <div className="bg-white py-9 border border-blue-600">
          <NOCApplicationForm
            nocApplicationDetail={nocApplicationDetail}
            qrCode_Url={qrCodeUrl} // Pass QR Code URL to child
            uniqueSerialNumber={nocApplicationDetail.noc_serial_no} // Pass uniqueSerialNumber to child
          />
        </div>
        <div className=" md:flex justify-center items-center mt-1 ">
          {nocApplicationDetail?.isverified &&
          !nocApplicationDetail?.isloanee &&
          nocApplicationDetail?.is_convenience_fee_paid ? (
            <>
              <PrintNOCApplication>
                <NOCApplicationForm
                  nocApplicationDetail={nocApplicationDetail}
                  qrCode_Url={qrCodeUrl}
                  uniqueSerialNumber={nocApplicationDetail.noc_serial_no}
                />
              </PrintNOCApplication>
            </>
          ) : null}
        </div>
      </>
      <div className="my-6 rounded-lg border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-200 px-4 py-3">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-base font-semibold text-slate-800">
                Payment Information
              </h3>

              <p className="text-xs text-slate-500">
                Record offline payment received from the applicant.
              </p>
            </div>

            {nocApplicationDetail?.is_convenience_fee_paid ? (
              <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
                Paid
              </span>
            ) : (
              <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">
                Pending
              </span>
            )}
          </div>
        </div>

        <div className="p-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <Dropdown
              defaultName="paymentmode"
              register={register}
              labelname="Payment Mode"
              required={true}
              pattern={null}
              errors={errors}
              classes="w-full rounded-md text-sm "
              setError={setError}
              clearError={clearErrors}
              control={control}
              data={rePaymentFormModeDD}
              defaultValue={selectedPaymentMode}
              setValue={setValue}
              onChangeInput={null}
              setSelected={setSelectedPaymentMode}
              selected={selectedPaymentMode}
              maxMenuHeight={150}
            />

            <div>
              <label className="mt-2.5 mb-1 block text-sm font-medium text-slate-700">
                Transaction Reference
              </label>

              <input
                type="text"
                value={paymentReference}
                onChange={(e) => setPaymentReference(e.target.value)}
                placeholder="Please enter transaction reference"
                className="w-full rounded-md border border-slate-300 px-3 py-1.5 text-sm focus:border-primary focus:outline-none"
              />
            </div>
          </div>

          <div className="mt-4">
            <TextArea
              defaultName="paymentremarks"
              register={register}
              name="Payment Remarks"
              required={false}
              pattern={null}
              errors={errors}
              placeholder="Enter payment remarks (optional)"
              setError={setError}
              clearError={clearErrors}
              autoComplete="off"
              type="text"
              classes="w-full resize-none rounded-md px-3 py-1.5 text-sm"
              onChangeInput={(e) => setPaymentRemark(e)}
              defaultValue={paymentRemark}
              setValue={setValue}
            />
          </div>

          {nocApplicationDetail?.is_convenience_fee_paid ? (
            <div className="mt-4 rounded-lg border border-green-200 bg-green-50 p-4">
              <div className="mb-3 flex items-center gap-2">
                <div className="h-2.5 w-2.5 rounded-full bg-green-500"></div>

                <h4 className="text-sm font-semibold text-green-800">
                  Payment Recorded Successfully
                </h4>
              </div>

              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div>
                  <p className="text-[10px] uppercase tracking-wide text-slate-500">
                    Payment Mode
                  </p>

                  <span
                    className={`mt-1 inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${
                      paymentModeColor[
                        nocApplicationDetail.convenience_fee_payment_mode
                      ] || paymentModeColor.Others
                    }`}
                  >
                    {nocApplicationDetail.convenience_fee_payment_mode}
                  </span>
                </div>

                <div>
                  <p className="text-[10px] uppercase tracking-wide text-slate-500">
                    Transaction Reference
                  </p>

                  <p className="mt-0.5 text-sm font-semibold text-slate-800">
                    {nocApplicationDetail?.payment_reference ||
                      nocApplicationDetail?.order_no ||
                      "-"}
                  </p>
                </div>

                <div>
                  <p className="text-[10px] uppercase tracking-wide text-slate-500">
                    Received By
                  </p>

                  <p className="mt-0.5 text-sm font-semibold text-slate-800">
                    {nocApplicationDetail?.payment_received_by || "-"}
                  </p>
                </div>

                <div>
                  <p className="text-[10px] uppercase tracking-wide text-slate-500">
                    Received At
                  </p>

                  <p className="mt-0.5 text-sm font-semibold text-slate-800">
                    {nocApplicationDetail?.payment_received_at
                      ? new Date(
                          nocApplicationDetail.payment_received_at,
                        ).toLocaleString("en-IN")
                      : "-"}
                  </p>
                </div>
              </div>

              {nocApplicationDetail?.payment_remark && (
                <div className="mt-4">
                  <p className="text-[10px] uppercase tracking-wide text-slate-500">
                    Payment Remarks
                  </p>

                  <div className="mt-1 rounded-md border border-slate-200 bg-white p-2.5 text-sm text-slate-700">
                    {nocApplicationDetail.payment_remark}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="mt-4 flex justify-end">
              <button
                type="button"
                onClick={verifyNocApplicationPayment}
                className="rounded-lg bg-primary px-5 py-2 text-sm font-medium text-white transition hover:opacity-90"
              >
                Mark Payment Received
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white shadow-sm">
        {/* Header */}
        <div className="border-b border-slate-200 px-4 py-3">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-base font-semibold text-slate-800">
                Loan Verification
              </h3>

              <p className="text-xs text-slate-500">
                Verify whether the applicant has any active loan or pending
                dues.
              </p>
            </div>

            {nocApplicationDetail?.isverified ? (
              <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
                Verified
              </span>
            ) : (
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                Pending
              </span>
            )}
          </div>
        </div>

        {/* Body */}
        <div className="p-4">
          {/* Payment Warning */}
          {!nocApplicationDetail?.is_convenience_fee_paid && (
            <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3">
              <div className="flex items-start gap-2">
                <div className="mt-1 h-2 w-2 rounded-full bg-amber-500" />

                <div>
                  <p className="text-sm font-medium text-amber-800">
                    Payment Pending
                  </p>

                  <p className="mt-0.5 text-xs text-amber-700">
                    Payment must be recorded before the application can be
                    verified.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Remarks */}
          <TextArea
            defaultName="remarks"
            register={register}
            name="Verification Remarks"
            required={true}
            pattern={null}
            errors={errors}
            placeholder="Enter verification remarks..."
            setError={setError}
            clearError={clearErrors}
            autoComplete="off"
            type="text"
            classes="w-full resize-none rounded-md px-3 py-1.5 text-sm"
            onChangeInput={(e) => {
              setRemark(e);

              if (e !== "") {
                setRemarkError(false);
              } else {
                setRemarkError(true);
              }
            }}
            defaultValue=""
            setValue={setValue}
          />

          {/* Buttons */}
          <div className="mt-5 flex flex-wrap justify-end gap-2">
            <SubmitButton
              disabled={!nocApplicationDetail?.is_convenience_fee_paid}
              isSubmitting={isSubmitting}
              label="Approve NOC"
              className={`${
                !nocApplicationDetail?.is_convenience_fee_paid
                  ? "cursor-not-allowed opacity-50"
                  : button
              }`}
              onClick={() => {
                if (remarkError) return;

                setShowModal(true);
              }}
            />

            <SubmitButton
              disabled={!nocApplicationDetail?.is_convenience_fee_paid}
              isSubmitting={isSubmitting}
              label="Reject NOC"
              className={`${
                !nocApplicationDetail?.is_convenience_fee_paid
                  ? "cursor-not-allowed opacity-50"
                  : delete_button
              }`}
              onClick={() => {
                if (remarkError) return;

                setShowRevertModal(true);
              }}
            />
          </div>
        </div>
      </div>
      <ConfirmationModal
        open={showModal}
        setOpen={setShowModal}
        message={`Are you sure the applicant is not a loanee?`}
        btnName={"Confirm"}
        onConfirm={() => verifyNocApplication({ is_loanee: false })}
      />
      <ConfirmationModal
        open={showRevertModal}
        setOpen={setShowRevertModal}
        message={"Are you sure the applicant is a loanee?"}
        btnName={"Confirm"}
        onConfirm={() => verifyNocApplication({ is_loanee: true })}
        color={"red"}
      />{" "}
    </>
  ) : (
    <LoadingModal message={"Loading"} />
  );
}

const NOCApplicationForm = ({
  nocApplicationDetail,
  qrCode_Url,
  uniqueSerialNumber,
}) => {
  const [qrCodeUrl, setQRCodeUrl] = useState(null);
  const [qrCodeUrlStatus, setQRCodeUrlStatus] = useState(false);

  const is_parcha =
    nocApplicationDetail?.noc_purpose === "REGISTRATION/MUTATION" ||
    nocApplicationDetail?.noc_purpose === "PARCHA" ||
    nocApplicationDetail?.noc_purpose === "registration/property mutation" ||
    nocApplicationDetail?.noc_purpose === "lost of Parcha";

  useEffect(() => {
    if (uniqueSerialNumber) {
      const textToEncode = `https://sikkimsabcco.com/view-noc-application/${uniqueSerialNumber}`;
      setQRCodeUrl(textToEncode);

      setQRCodeUrlStatus(true);
    }
  }, [uniqueSerialNumber]);

  return (
    <>
      <div className="noc-content w-full bg-white px-6 text-[13px] leading-relaxed text-justify">
        <div className="w-full">
          <div className="noc-header flex w-full items-center justify-between gap-4 py-3">
            <div className="flex gap-3 items-center my-6 ">
              <img
                className="noc-logo h-16 w-16 shrink-0 object-contain"
                src={sabccoLogo}
              />
              <div>
                <p className="noc-title text-center text-[15px] font-semibold leading-tight">
                  Sikkim SC / ST / OBC Development Corporation.Ltd. (SABCCO)
                </p>
                <p className="noc-address mt-1 text-[12px] leading-tight">
                  Chorten Monastery Road, Deorali, Gangtok, Sikkim - 737102
                </p>
              </div>
            </div>
            <div>
              {/* <p className="text-center text-xs"> QR Code:</p> */}
              {qrCodeUrl || qrCodeUrlStatus ? (
                <div className="noc-qr flex h-24 w-24 shrink-0 items-center justify-end">
                  <QRCode
                    size={20}
                    style={{
                      height: "auto",
                      width: "90%",
                    }}
                    value={`${qrCodeUrl}`}
                  />
                </div>
              ) : (
                <p>Loadig QR Code ...</p>
              )}
            </div>
          </div>
        </div>

        <div className="noc-meta flex items-center justify-between border-y border-gray-200 py-2 text-[12px]">
          {nocApplicationDetail.noc_serial_no ? (
            <>
              <p className="font-semibold">
                Serial No.: {nocApplicationDetail.noc_serial_no}
              </p>
            </>
          ) : null}

          {nocApplicationDetail.createdat ? (
            <>
              <p className="font-semibold">
                Date: {getFormattedDateDDMMYYYY(nocApplicationDetail.createdat)}
              </p>
            </>
          ) : null}
        </div>

        <p className="text-center text-[12px] font-semibold text-yellow-600">
          {nocApplicationDetail?.isverified ? "" : "Unverified"}
        </p>

        <div className="mb-9">
          <p className="noc-heading mb-4 text-center text-[14px] font-bold tracking-wide">
            TO WHOM IT MAY CONCERN
          </p>

          <p className="noc-paragraph leading-[1.45]">
            This is to certify that Shri/Smt/Kumari
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_name}{" "}
            </span>
            , S/o, D/o, W/o
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_relative_name}{" "}
            </span>
            , resident of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_resident}{" "}
            </span>
            , does not have any outstanding loan or other dues as reflected in
            the books of this Corporation. Hence, this Corporation has no
            objection to the applicant obtaining this No Objection Certificate
            for the purpose of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_purpose}{" "}
            </span>
            {nocApplicationDetail?.noc_department_name && (
              <>
                {" "}
                in{" "}
                <span className="font-semibold">
                  {nocApplicationDetail?.noc_department_name}
                </span>
                {String(nocApplicationDetail?.noc_department_name).includes(
                  "Department",
                ) ||
                String(nocApplicationDetail?.noc_department_name).includes(
                  "Dept.",
                )
                  ? null
                  : " Department"}
              </>
            )}
            .
          </p>

          {is_parcha ? (
            <p className="noc-paragraph pt-2 leading-[1.45]">
              Percha/Land Title bearing Khatian No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khatian_no}{" "}
              </span>{" "}
              Khasra No./Plot No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khasra_no}{" "}
              </span>{" "}
              and Area of{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_area}{" "}
              </span>{" "}
              Hectares registered in the name{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.parcha_holder_name}{" "}
              </span>{" "}
              situated at{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_situated}{" "}
              </span>
            </p>
          ) : null}

          <p className="noc-paragraph pt-2 leading-[1.45]">
            This certificate is issued without prejudice to the Corporation's
            right to recover the loan amount if it is found at any later point
            of time that he/she owes any amount to this Corporation.
          </p>

          <p className="noc-paragraph pt-2 leading-[1.45]">
            This certificate is valid for a period of 6 (Six) months from the
            date of issue.
          </p>
        </div>

        <div className="noc-signature mt-8 flex items-end justify-between">
          <div>
            <p className="">Prepared and checked by ........................</p>
            <p className="font-semibold pt-6">{formatINRCurrency(150)}/-</p>
          </div>

          {nocApplicationDetail?.isverified &&
          !nocApplicationDetail?.isloanee &&
          nocApplicationDetail?.is_convenience_fee_paid ? (
            <>
              <div>
                {/* <img
                  src={DigitalSignature}
                  className="w-[12rem] h-auto object-cover"
                  alt="Digital signature"
                /> */}

                {/* <p className="mt-16">Asstt. Manager/Manager/Dy.G.M</p> */}
                <div className="text-center">
                  <p className="font-medium">General Manager</p>
                </div>
              </div>
            </>
          ) : (
            <div className="mt-8 text-center">
              <p>General Manager</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
